export default __webpack_public_path__ + "static/media/ic_campaign.dc2f2c33.svg";